module.exports = __webpack_public_path__ + "static/media/whistleout.66609faf.png";